import styled from 'styled-components/macro';
import Column from 'components/Column';

export const Container = styled(Column)`
  background: ${({ theme }) => theme.colors.black};
  width: 100%;
  height: 100%;
`;
